import { Categories } from "../components/DataValues";

const categories = Categories

export default categories